
// 开通城市
export const openingCities = ['宁波', '南京', '合肥', '杭州']
